import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';
import type { ActivityLogListParams } from '@core/repositories/ActivityLogRepository';

export const useActivityLogs = (
  workspaceId: string | undefined,
  params?: ActivityLogListParams,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.activityLogs(workspaceId ?? '', params),
    queryFn: () => container.activityLogs.list(workspaceId as string, params),
    enabled: Boolean(workspaceId),
  });
};
